/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1BannerBanneridLangsQueryResponse,
  GetApiV1BannerBanneridLangsPathParams,
  GetApiV1BannerBanneridLangsQueryParams,
  GetApiV1BannerBanneridLangs401,
  GetApiV1BannerBanneridLangs404,
  GetApiV1BannerBanneridLangs500,
} from "../../types/bannerIdiomasController/GetApiV1BannerBanneridLangs.ts";

function getGetApiV1BannerBanneridLangsUrl(
  bannerId: GetApiV1BannerBanneridLangsPathParams["bannerId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/banner/${bannerId}/langs` as const,
  };
  return res;
}

/**
 * @description Retorna uma lista paginada das traduções (idiomas) do banner. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:bannerId/langs}
 */
export async function getApiV1BannerBanneridLangs(
  bannerId: GetApiV1BannerBanneridLangsPathParams["bannerId"],
  params?: GetApiV1BannerBanneridLangsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1BannerBanneridLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1BannerBanneridLangs401
      | GetApiV1BannerBanneridLangs404
      | GetApiV1BannerBanneridLangs500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1BannerBanneridLangsUrl(bannerId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
